import { ChangeDetectionStrategy, Component, Input, Optional } from '@angular/core';
import { ActionCreator, Store } from '@ngrx/store';
import { isIos } from '@capital-access/firefly/components';
import { ProfileLinkProvider, ProfileType } from '@capital-access/profiles/common';
import { ProfilePreviewType } from '../../models/preview-type.model';
import { getProfilePreviewAction, getProfileType } from '../../utils/profile-preview.utils';

@Component({
  selector: 'ca-profile-preview-link',
  templateUrl: './profile-preview-link.component.html',
  styleUrls: ['./profile-preview-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfilePreviewLinkComponent {
  private _profileType!: ProfileType;

  //TODO: dataAutomationId should be hard-coded after updating all selectors in tests
  @Input() dataAutomationId?: string;
  @Input() class: string = 'link link-main';
  @Input() text!: string;
  @Input() prId?: number | null;
  @Input() crmId?: number | null;
  @Input() innerHTML?: string | null;
  @Input() title?: string | null;
  @Input() set type(value: ProfilePreviewType) {
    this._profileType = getProfileType(value);
  }
  @Input() backButtonPreviewDrawer = false;

  public get link() {
    return this.linkProvider.getProfileLink(this._profileType, this.prId, this.crmId);
  }

  protected get isIosDevice(): boolean {
    return isIos();
  }

  constructor(private linkProvider: ProfileLinkProvider, @Optional() private store: Store) {}

  openProfilePreview(event: Event) {
    event.preventDefault();
    const previewAction = getProfilePreviewAction(this._profileType) as ActionCreator<string, any>;
    this.store?.dispatch(
      previewAction({
        id: { prId: this.prId, crmId: this.crmId },
        backButtonPreviewDrawer: this.backButtonPreviewDrawer,
        name: this.text
      })
    );
  }
}
